import React, { useContext, useEffect, useState } from "react";
import { ThemeContext, ThemeConstants } from "../App";
import Spinner from "./Utils/Spinner";

export const Login = ({ auth }) => {
  const themeConfig = useContext(ThemeContext);
  const themeConstants = useContext(ThemeConstants);
  const currentTheme = process.env.REACT_APP_THEME;
  const marginTop = currentTheme === "homelink" ? "mt-[160px]" : "mt-24";

  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (!auth?.isAuthenticated) {
        setShowLogin(true);
      }
    }, 3000);
  }, [auth]);

  return (
    <>
      {showLogin ? (
        <div
          className={`bg-gray-100 w-max p-10 ${marginTop} mx-auto text-center rounded-md`}
        >
          <p className="font-semibold text-gray-700 text-lg capitalize">
            You have been logged out.
          </p>
          <p className="text-gray-500 text-base">Please log back in.</p>
          <hr className="my-4" />
          <a
            href={`https://${themeConstants.COGNITO_DOMAIN}/login?&state=STATE&scope=email+openid+profile&response_type=code&client_id=${themeConstants.COGNITO_APP_CLIENT_ID}&redirect_uri=${themeConstants.COGNITO_REDIRECT_URI}`}
            className={`${themeConfig.buttonBgColor} ${themeConfig.buttonHoverBgColor} text-white p-3 px-8 block rounded-md`}
          >
            Login
          </a>
        </div>
      ) : (
        <div className="my-32 h-40">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default Login;
